import { render, staticRenderFns } from "./PaginationWithPaging.vue?vue&type=template&id=7c849700&scoped=true&"
import script from "./PaginationWithPaging.vue?vue&type=script&lang=js&"
export * from "./PaginationWithPaging.vue?vue&type=script&lang=js&"
import style0 from "./PaginationWithPaging.vue?vue&type=style&index=0&id=7c849700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c849700",
  null
  
)

export default component.exports